import { isEmpty } from '../../../../utils/validation';
import { TYPES } from '../../RichTextEditorV2/utils/SlateUtilityFunctions';
import { deserializer } from './deserializer';
import { serializer } from './serializer';

const RTE_EMPTY_HTML = '<p></p>';
const RTE_EMPTY_HTML_WITH_LIST_STYLES =
  '<p style="margin:0;min-height:18px"></p>'; // needed as withList plugin library having side affects

const isEmptyRTEString = (editorState: any) => {
  if (!editorState) return true;

  const editorStateInHtml =
    typeof editorState === 'string' ? editorState : serializer(editorState);

  return (
    editorStateInHtml === RTE_EMPTY_HTML ||
    editorStateInHtml === RTE_EMPTY_HTML_WITH_LIST_STYLES
  );
};

/**
 * @function isEmptyHtmlFromString - This function checks if an HTML string is empty or not.
 * @param {string} htmlString - The HTML string to check.
 * @param {string[]} [saveHTMLTagArray=[]] - An optional array of HTML tags to preserve during the check.
 * @description If the HTML string contains any of these tags (like ['img', 'table']) present in 'saveHTMLTagArray',
 * it considers an HTML string as non-empty the function returns false.
 * If not, the function strips the HTML string of all tags, spaces, line breaks,
 * and other whitespace characters, and checks if the resulting string is empty. If the stripped string is empty returns true,
 * @returns {boolean} - Returns true if the HTML string is considered empty, and false otherwise.
 */
const isEmptyHtmlFromString = (
  htmlString: string,
  saveHTMLTagArray?: string[]
) => {
  if (isEmpty(htmlString)) return true;
  const htmlTagArr = ['img', ...(saveHTMLTagArray || [])]; // array of elemets which wants to save
  // Check if the HTML string contains an tag
  const isContains = htmlTagArr.some((element) =>
    new RegExp(`<${element}[^>]*>`, 'i').test(htmlString)
  );
  // If the string contains an tag, it's not empty
  if (isContains) {
    return false;
  }
  // Remove all HTML tags, spaces, line breaks, etc.
  const strippedString = htmlString
    .replace(/<[^>]*>/g, '')
    .replace(/\s|&nbsp;/g, '');
  // Check if the resulting string is empty
  return isEmpty(strippedString);
};

export const RTEUtils = {
  getEditorStateFromHtml: deserializer,
  getHtmlFromEditorState: serializer,
  emptyHtml: RTE_EMPTY_HTML,
  emptyHtmlWithListStyle: RTE_EMPTY_HTML_WITH_LIST_STYLES,
  emptyEditorState: [{ type: TYPES.PARAGRAPH, children: [{ text: '' }] }],
  isEmpty: isEmptyRTEString,
  isEmptyHtmlFromString,
};
